import axios from 'axios'
import { BASE_PATH_PORTAL } from '../../constants'

export const logout = async () => {
  return await axios.get(`${BASE_PATH_PORTAL}/api/v1/logout`)
}
